module.exports = __webpack_public_path__ + "static/media/AmazonFresh Final Report.74a6defe.pdf";